// src/index.ts
export * from "@primeuix/styled";
